import Vue from 'vue'
import VueRouter from 'vue-router'
import testBBB from '../views/testBBB.vue'
import Faq from '../views/Faq.vue'
import Test from '../views/404.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'BBBTest',
    component: testBBB,
    meta: { title: 'Accueil' },
  },
  {
    path: '/recommandations',
    name: 'recommandations',
    props: {
      faq: false,
      //recharge: false,
    },
    component: Faq,
    meta: { title: 'Recommandations' },
  },
  {
    path: '/faq',
    name: 'faq',
    props: {
      faq: true,
      //recharge: false,
    },
    component: Faq,
    meta: { title: 'Foire aux questions' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import('../views/Faq.vue')
  },
/*
  {
    path: '/test',
    name: 'test',
    component: tests,
    meta: { title: 'Test' },
  },
*/
  {
    path: '*',
    name: 'Not Found',
    component: Test,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
